import React, { useEffect } from 'react';
import rocketBoyImg from '../../../assets/images/barbfullLogo.png';
import { Link } from 'react-router-dom';
import { useTrackingContext } from '../../../context/trackingContext';

const items = [{ id: 1, title: 'Forgot Password' }];

const Home = ({ handleNextStep }) => {
  const { trackPageView, trackClick } = useTrackingContext();

  const handleClickNextStep = (id, title) => {
    trackClick({ btnName: title });

    handleNextStep(id); // Call the prop function without invoking it immediately
  };

  useEffect(() => {
    trackPageView({
      pageName: 'Login help page'
    });
  }, []);
  return (
    <>
      <div id="login-help-home">
        <h1 className="font-Korolev-Bold text-5xl xl:text-5xl uppercase mb-6">
          login <br /> help
        </h1>

        <img src={rocketBoyImg} alt="build rocket boy" className="w-full mb-5" />

        <p className="text-base text-black mb-5">
          Select the option below that best describes the log in issue you are experiencing.{' '}
        </p>

        <div className="grid grid-cols-3 gap-5 mb-5">
          {items &&
            items.map((item) => {
              const { id, title } = item;
              return (
                <div
                  key={id}
                  onClick={() => handleClickNextStep(id, title)}
                  className="login-block cursor-pointer h-[100px] w-[100px] border border-black pt-6 relative group hover:bg-black hover:shadow-[4px_4px_gray] transition-all duration-75">
                  <p className=" text-black absolute bottom-0 left-1 max-w-[35px] text-sm group-hover:text-white transition-all duration-75">
                    {title}
                  </p>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default Home;
